module.exports = __webpack_public_path__ + "img/weather38.c0bc568e.png";